export const TIMEOUT = 5000;

export const NOTIFICATIONS_COMMUNITY_ADD_FAVORITE_SUCCESS =
  'Community Added to your favorites';

export const NOTIFICATIONS_COMMUNITY_ADD_FAVORITE_FAILED =
  'Failed to add community to favorites. Please try again.';

export const NOTIFICATIONS_COMMUNITY_REMOVE_FAVORITE_SUCCESS =
  'Community Removed';

export const NOTIFICATIONS_COMMUNITY_REMOVE_FAVORITE_FAILED =
  'Failed to remove community from favorites. Please try again.';

export const NOTIFY_MESSAGE_NEW = 'notify.message.new';

export const NOTIFY_AGENT_MATCHED = 'notify.client.match';

export const NOTIFY_AGENT_MATCHED_TIMEOUT = 15000;

export const NOTIFY_AGENT_RECEIVED_REQUEST =
  'We have received your request and we will get back to you soon.';

export const NOTIFICATIONS_LISTING_ADD_FAVORITE_SUCCESS =
  'Listing Added to your favorites';

export const NOTIFICATIONS_LISTING_ADD_FAVORITE_FAILED =
  'Failed to add listing to favorites. Please try again.';

export const NOTIFICATIONS_LISTING_REMOVE_FAVORITE_SUCCESS = 'Listing Removed';

export const NOTIFICATIONS_LISTING_REMOVE_FAVORITE_FAILED =
  'Failed to remove listing from favorites. Please try again.';
